import camelcaseKeys from 'camelcase-keys';
import decamelizeKeys from 'decamelize-keys';
export var CaseStyle = {
    CAMEL_CASE: 'CAMEL_CASE',
    SNAKE_CASE: 'SNAKE_CASE',
};
export var isObject = function (data) {
    return data && typeof data === 'object' && !Array.isArray(data);
};
export var convertObjectKeysCase = function (_a) {
    var _b = _a === void 0 ? {} : _a, _c = _b.caseStyle, caseStyle = _c === void 0 ? CaseStyle.SNAKE_CASE : _c, _d = _b.excludePaths, excludePaths = _d === void 0 ? [] : _d, _e = _b.object, object = _e === void 0 ? {} : _e;
    switch (caseStyle) {
        case CaseStyle.SNAKE_CASE:
            return decamelizeKeys(object, {
                deep: true,
                exclude: excludePaths || [],
            });
        case CaseStyle.CAMEL_CASE:
            return camelcaseKeys(object, {
                deep: true,
                stopPaths: excludePaths || [],
            });
        default:
            return object;
    }
};
